import JwtService from './jwtService'

export default function getJwt(axiosIns, jwtOverrideConfig) {
  return new JwtService(axiosIns, jwtOverrideConfig)
}
